import axiosService from '../axios'

export const list = (params?: any) => {
  return axiosService({
    url: '/api.user',
    method: 'get',
    params,
  })
}

export const listStaff = () => {
  return axiosService({
    url: '/api.user/staff',
    method: 'get',
  })
}

export const getMe = () => {
  return axiosService({
    url: '/api.user/me',
    method: 'post',
  })
}

export const get = (id: number) => {
  return axiosService({
    url: `/api.user/${id}`,
    method: 'get',
  })
}

export const update = (id: any, data: any) => {
  return axiosService({
    url: `/api.user/${id}`,
    method: 'put',
    data,
  })
}

export const destroy = (id: number) => {
  return axiosService({
    url: `/api.user/${id}`,
    method: 'delete',
  })
}

export const create = (data: any) => {
  return axiosService({
    url: '/api.user',
    method: 'post',
    data,
  })
}
